/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';
import { useSessionContext } from '@exo/frontend-common-session-context';
import { parseTokenExpiryTime } from '@exo/frontend-common-app-identity-and-access';
import { v4 as uuidv4 } from 'uuid';

const AUTHENTICATE = gql`
  mutation Auth($username: String!, $password: String!) {
    authLogin(username: $username, password: $password) {
      token
      expiresAt
      isPasswordExpired
    }
  }
`;

const LOGOUT = gql`
  mutation Logout {
    authLogout
  }
`;

export const useAuthentication = () => {
  const session = useSessionContext();

  const { language, selectedLanguage } = session;

  const [authenticate, { loading: authenticateLoading }] = useMutation(AUTHENTICATE);
  const [logoutMutation] = useMutation(LOGOUT);

  return {
    authenticate: async (username, password) => {
      const res = await authenticate({ variables: { username, password } });
      if (!res.data.authLogin.isPasswordExpired) {
        session.update({
          token: res.data.authLogin.token,
          tokenExpiryTime: parseTokenExpiryTime(res.data.authLogin.expiresAt),
          username,
          firstName: '',
          clientId: uuidv4(),
          type: 'USER',
          roles: ['user']
        });
      }
      return {
        token: res.data.authLogin.isPasswordExpired ? null : res.data.authLogin.token,
        username,
        isPasswordExpired: res.data.authLogin.isPasswordExpired
      };
    },
    authenticateLoading,
    logout: async () => {
      await logoutMutation();
      session.replace({ roles: [], language, selectedLanguage });
    }
  };
};
